<template>
    <div>
        <div class="icp">
            <div style="text-align: center;line-height: 40px; color: aliceblue;">
                <label> 共享类产品小程序分润系统&nbsp;|&nbsp;分销系统&nbsp;|&nbsp;APP/网站制作&nbsp;|&nbsp;线路板定制开发&nbsp;|&nbsp;18124616780 </label>
            </div>
            <div style="text-align: center;">
                <a href="http://beian.miit.gov.cn/" target="_blank">{{ record }}</a> {{ ` © ${year} ${author} ` }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            year: new Date().getFullYear(),
            author: '深圳佳源通信2022-2050',
            record: '粤ICP备2023049728号-1',
        };
    },
}
</script>

<style>
.icp {
    bottom: 0;
    font-size: 12px;
    right: 0;
    margin: 0px 0px;
    width: 100%;
    height: 100px;
    white-space: pre;
    text-align: center;
    color: gray;
    z-index: 1000;
    background-color: #2e2e41;
    justify-content: center;
    align-items: center;
}

.icp>a {
    color: gray;
    text-decoration: none;
}

.icp>a:hover {
    color: aqua;
    text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/copyright-icp.vue